/**
 * <wellf-header> - floating nav behaviour.
 * - Toggles the mobile dropdown menu (keyboard + pointer).
 * - Keeps the bag count in sync with the Ajax cart via the
 *   `wellf:cart:updated` event (dispatched by the buy card) and on pageshow.
 */
class WellfHeader extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-nav-toggle]');
    this.menu = this.querySelector('[data-nav-menu]');
    this.countEls = document.querySelectorAll('[data-cart-count]');

    if (this.toggle && this.menu) {
      this._onToggle = () => this.setOpen(this.menu.dataset.open !== 'true');
      this.toggle.addEventListener('click', this._onToggle);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.menu.dataset.open === 'true') this.setOpen(false);
      });
    }

    this._onCart = (e) => {
      const count = e && e.detail && typeof e.detail.count === 'number' ? e.detail.count : null;
      if (count !== null) this.renderCount(count);
    };
    document.addEventListener('wellf:cart:updated', this._onCart);

    // Refresh on bfcache restore so the count is never stale.
    window.addEventListener('pageshow', () => this.refreshCount());
  }

  disconnectedCallback() {
    if (this.toggle && this._onToggle) this.toggle.removeEventListener('click', this._onToggle);
    document.removeEventListener('wellf:cart:updated', this._onCart);
  }

  setOpen(open) {
    this.menu.dataset.open = open ? 'true' : 'false';
    this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  renderCount(count) {
    this.countEls.forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      const link = el.closest('.nav__icon--cart');
      if (link) link.setAttribute('aria-label', `Bag, ${count} items`);
    });
  }

  async refreshCount() {
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      this.renderCount(cart.item_count);
    } catch (_) { /* offline / blocked - keep server-rendered count */ }
  }
}
customElements.define('wellf-header', WellfHeader);
